import CreatePageModalContainer from './CreatePageModalContainer'
import CreatePageModal from './CreatePageModal'
export { CreatePageModal }
export { CreatePageModalContainer }
export default CreatePageModalContainer



// WEBPACK FOOTER //
// ./src/components/CreatePageModal/index.js